<template>
  <div class="CTabs">
    <div
      v-for="tab in list"
      :key="tab.name"
      :class="['CTab', tab.name === active && 'active']"
      @click="tabChangeHandler(tab)"
    >
      {{ tab.title }}
      <span v-if="tab.name === active" class="tip"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CTabs',
  props: {
    active: {
      type: [String, Number],
      default: 0,
    },
    list: {
      type: Array,
      required: true,
      default: () => {
        return []
      },
    },
  },
  methods: {
    tabChangeHandler(tab) {
      this.$emit('change', tab.name)
    },
  },
}
</script>

<style scoped lang="scss">
.CTabs {
  width: 100%;
  height: 50px;
  line-height: 50px;
  position: relative;
  z-index: 10;
  display: flex;
  flex-direction: row;
  align-items: center;
  box-sizing: border-box;
  padding: 0 16px;
  position: relative;
  background: #37c049;
  color: #fff;
}
.CTab {
  height: 18px;
  font-size: 16px;
  font-family: Source Han Sans CN-Medium, Source Han Sans CN;
  font-weight: 500;
  color: #fff;
  line-height: 18px;
  margin-right: 2px;
  position: relative;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  &.active {
    color: #fff;
    .tip {
      position: absolute;
      bottom: -8px;
      left: 70px;
      width: 24px;
      height: 3px;
      background: #fff;
      border-radius: 143px 143px 143px 143px;
      opacity: 1;
    }
  }
}
</style>
